import React, { useEffect, useState } from "react";
import Axios from "axios";
import QRCode from "react-qr-code";

export default function QRList({ match }) {
  const eventId = match?.params?.id;
  const [badgeNos, setBadgeNos] = useState([]);

  useEffect(() => {
    if (eventId) {
      (async () => {
        const { data } = await Axios.get(`./api/attendee/getAtendeesList?eventId=${eventId}`);
        setBadgeNos(data?.map(({ badgeNo, firstName, lastName }) => ({ badgeNo, firstName, lastName })));
      })();
    }
  }, [eventId]);

  return (
    <div className="scroll-container" style={{ width: "100%", height: "100vh", overflowY: "auto" }}>
      {badgeNos?.map(({ badgeNo, firstName, lastName }) => (
        <div className="scroll-child" key={badgeNo} style={{ height: "100%", width: "100%" }}>
          <div style={{ display: "flex", alignItems: "center", columnGap: "20px", margin: "auto", width: 500, height: "100%" }}>
            <QRCode key={badgeNo} value={badgeNo} size={200} />
            <h3>
              {firstName} {lastName}
            </h3>
          </div>
        </div>
      ))}
    </div>
  );
}
